module.exports = __webpack_public_path__ + "img/banner.99b63734.jpg";